<script>
/**
 * @typedef {Object} Cargo
 * @property {string} nombre_cargo - Name of the position.
 * @property {string} __typename - GraphQL type name.
 */

/**
 * @typedef {Object} Usuario
 * @property {string} id_usuario - User ID.
 * @property {string} primer_nombre - First name.
 * @property {string} apellido_paterno - Last name.
 * @property {string} imagen_perfil - Profile image URL.
 * @property {Cargo[]} cargo - Array of cargos (positions).
 * @property {string} __typename - GraphQL type name.
 */

/**
 * @typedef {Object} Like
 * @property {string} id_like - Like ID.
 * @property {Usuario} usuario - User who liked.
 * @property {string} __typename - GraphQL type name.
 */

/**
 * @typedef {Like[]} LikesArray
 */

/**
 * Likes component.
 * @component
 * @prop {LikesArray} likes - Array of likes.
 */
export default {
  name: "Likes",
  props: {
    /**
     * Array of likes.
     * @type {LikesArray}
     */
    likes: {
      type: Array,
      required: true,
    },
  },
};
</script>

<template>
  <div class="box-likes__overlay" @click="$emit('close')">
    <transition name="slide-up">
      <article class="box-likes bg-white p-3">
        <header class="box-likes__header py-2">
          <h4 class="box-likes__title font-title text-center  font-700 mb-0">También les gusta</h4>
        </header>
        <main class="box-likes__main py-4 scroll">     
          <div
            v-for="like in likes"
            class="d-flex box-likes__item"
            :key="like.id_like">
            <div>
              <img
              v-if="like.usuario.imagen_perfil"
                  width="50"
                  height="50"
                class="box-likes__img  rounded-circle me-3"
                :src="like.usuario.imagen_perfil"
                alt="Profile image"
              />
              <img
                  v-else
                  width="50"
                  height="50"
                  src="@/assets/img/intranet/header/icono-header-btn-contacto.svg"
                  class="img-object-cover rounded-circle me-3"
                  alt="Imagen de usuario"
                />
            </div>
            <div class="col-9 box-likes__info">
              <p class="mb-0">
                {{ like.usuario.primer_nombre }} {{ like.usuario.apellido_paterno }}
              </p>
              <p>{{ like.usuario.cargo[0]?.nombre_cargo }}</p>
            </div>
          </div>
        </main>
      </article>
    </transition>
  </div>
</template>
<style lang="scss" scoped>
.box-likes__overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: end;
  z-index: 1050;
}
.box-likes {
  height: 500px;
  width: 400px;
  max-height: 90%;
  box-sizing: border-box;
  border-radius: 30px 30px 0 0;
  &__header {
  }
  &__title {
  color: var(--bs-link-color);
  }
  &__main {
    height: 100%;
  }
  &__item {
  }
  &__img {
  }
  &__info {
  }
}
</style>
